import { environment } from '@env';
import '@services/developer-console/developer-console.store';

type IBaseLogger = typeof console & { printLogs: boolean };
type ILoggerPropKey = keyof Console | 'printLogs';
type IProxyGetRes = (...args: unknown[]) => unknown;

function proxyGet(target: IBaseLogger, propKey: ILoggerPropKey): IProxyGetRes
{
    const origMethod = (target as any)[ propKey ];
    if (typeof origMethod === 'function')
    {
        return (...args: unknown[]) =>
        {
            if (propKey === 'error')
            {
                return origMethod(...args);
            }

            if (target.printLogs)
            {
                const date = new Date();
                const dateString = `%c[${ date.toUTCString() }]`;
                const cssStyle =
                    'background-color: var(--bg-accent);' +
                    'color: #ffffff;' +
                    'font-weight: 600;' +
                    'border-radius: 2px;' +
                    'padding: 2px;' +
                    'font-size: 10px';
                return origMethod(dateString, cssStyle, ...args);
            }
        };
    }

    return origMethod;
}

const loggerInstance = Object.create(globalThis.console) as IBaseLogger;
loggerInstance.printLogs = environment.print_logs;

const logger = new Proxy(loggerInstance, { get: proxyGet }) as unknown as IBaseLogger;

export { logger };
